"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = exports.AccordionContext = void 0;
var React = __importStar(require("react"));
var Disclosure_1 = require("reakit/Disclosure");
var use_deep_compare_1 = require("use-deep-compare");
var Card_1 = require("../Card");
exports.AccordionContext = React.createContext(undefined);
var Accordion = function (_a) {
    var children = _a.children, isExpanded = _a.isExpanded, disabled = _a.disabled, rest = __rest(_a, ["children", "isExpanded", "disabled"]);
    var disclosure = (0, Disclosure_1.useDisclosureState)({ visible: !disabled && isExpanded });
    var value = (0, use_deep_compare_1.useDeepCompareMemo)(function () { return disclosure; }, [disclosure]);
    return (React.createElement(exports.AccordionContext.Provider, { value: __assign({ disabled: disabled }, value) },
        React.createElement(Card_1.Card, __assign({ flexDirection: 'column', padding: 'space24' }, rest), children)));
};
exports.Accordion = Accordion;
//# sourceMappingURL=Accordion.js.map